import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { IAttractionDetails } from "../attractionModel";
import { API_PORTAL_URL } from "../../../lib/config";
import { ErrorToast } from "../../../components/common/Toast";

export const getAttractionByURL = createAsyncThunk(
  "Attraction/AttractionFindByURL",
  async (AttractionURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Attraction/AttractionFindByURL`,
        { AttractionURL },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        AttractionURL: result.AttractionURL,
        PropertyID: result.PropertyID,
        PropertyName: result.PropertyName,
        PropertyURL: result.PropertyURL,
        AttractionCategory: result.AttractionCategory,
        TagLine: result.TagLine,
        Distance: result.Distance,
        TravelTime: result.TravelTime,
        BestTime: result.BestTime,
        Duration: result.Duration,
        Description: result.Description || "",
        Dos: result.Dos,
        Donts: result.Donts,
        MainImage: result.MainImage,
        BannerImage: result.BannerImage,
        MetaTitle: result.MetaTitle,
        MetaDescription: result.MetaDescription,
        MetaKeywords: result.MetaKeywords,
        IsMustVisit: result?.IsMustVisit,
        IsActive: result.IsActive ? 1 : 2,
        BestTimes: result.BestTimes ?? [],
        HowToReach: result.HowToReach ?? [],
        ThingsToDo: result.ThingsToDo ?? [],
        WhyVisit: result.WhyVisit ?? [],
        Nearby: result?.Nearby ?? [],
        Images: result?.Images ?? [],
      } as IAttractionDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
